import * as Popover from '@radix-ui/react-popover';
import type { ReactNode } from 'react';
import { cn } from '@cyphex/ui';

export interface PickerPopoverProps {
  trigger: ReactNode;
  children: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  align?: 'start' | 'center' | 'end';
  side?: 'top' | 'bottom';
  label: string;
  className?: string;
}

/**
 * Shared floating surface for the emoji / GIF / sticker pickers.
 * `@cyphex/ui` has no popover primitive (Dropdown is menu-only), so this is
 * the one place Radix Popover is wrapped — using design tokens exclusively.
 */
export function PickerPopover({
  trigger,
  children,
  open,
  onOpenChange,
  align = 'start',
  side = 'top',
  label,
  className,
}: PickerPopoverProps) {
  return (
    <Popover.Root open={open} onOpenChange={onOpenChange}>
      <Popover.Trigger asChild>{trigger}</Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          side={side}
          align={align}
          sideOffset={8}
          aria-label={label}
          className={cn(
            'z-dropdown w-80 animate-scale-in rounded-2xl border border-border bg-popover p-2 text-popover-foreground shadow-dropdown',
            className,
          )}
        >
          {children}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
